import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useContext, useState } from 'react';
import { Label } from 'semantic-ui-react';

const MatchVote = ({ match }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { teams_info, details_info } = sportsSeason_state ?? {};
  const { teams } = teams_info ?? {};
  const { details } = details_info ?? {}
  const { allowMatchVote } = details ?? {}

  const [selectedWinnerKey, setSelectedWinnerKey] = useState()

  const awayName = match?.away?.name
  const homeName = match?.home?.name

  const handleClick_away = (e) => {
    e.stopPropagation()
    setSelectedWinnerKey(match?.away?._itemKey)
  }

  const handleClick_home = (e) => {
    e.stopPropagation()
    setSelectedWinnerKey(match?.home?._itemKey)
  }

  const lbl_away = () => <div><Label className={selectedWinnerKey === match?.away?._itemKey ? 'sel' : ''} size='tiny' onClick={(e) => { handleClick_away(e) }}>{awayName}</Label></div>
  const lbl_home = () => <div><Label className={selectedWinnerKey === match?.home?._itemKey ? 'sel' : ''} size='mini' onClick={(e) => { handleClick_home(e) }}>{homeName}</Label></div>
  const lbl_votes = () => <div><Label size='mini'>{'# of Votes'}</Label></div>

  const matchVote = () => {
    return <div className={`match-pred-vote`}>
      {lbl_away()}
      {lbl_votes()}
      {lbl_home()}
    </div>
  }

  return !allowMatchVote ? matchVote() : <div></div>
}

export default MatchVote